/**
 * Love Store Paris — Header interactions (Phase 1)
 * Scroll hide/show, mobile menu, search overlay, cart badge refresh
 */
(function () {
  'use strict';

  var SCROLL_DELTA = 8;

  function initHeader(root) {
    if (!root || root.dataset.lspInit === 'true') return;
    root.dataset.lspInit = 'true';

    var lastScrollY = window.scrollY;
    var mobileOpen = false;
    var searchOpen = false;

    var menuToggle = root.querySelector('[data-lsp-menu-toggle]');
    var menuPanel = root.querySelector('[data-lsp-mobile-nav]');
    var searchToggle = root.querySelector('[data-lsp-search-toggle]');
    var searchOverlay = root.querySelector('#lsp-search-overlay');
    var searchInput = root.querySelector('#lsp-search-input');
    var searchClose = root.querySelector('[data-lsp-search-close]');
    var cartBadge = root.querySelector('[data-lsp-cart-count]');

    function setMobileOpen(open) {
      mobileOpen = open;
      root.classList.toggle('is-mobile-open', open);
      document.documentElement.classList.toggle('lsp-menu-open', open);
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        menuToggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      }
      if (open) {
        setSearchOpen(false);
        root.classList.remove('is-hidden');
      }
    }

    function setSearchOpen(open) {
      searchOpen = open;
      root.classList.toggle('is-search-open', open);
      if (searchToggle) {
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      if (open) {
        setMobileOpen(false);
        window.requestAnimationFrame(function () {
          if (searchInput) searchInput.focus();
        });
      } else if (searchInput) {
        searchInput.blur();
      }
    }

    function onScroll() {
      var y = window.scrollY;
      root.classList.toggle('is-scrolled', y > 10);

      if (mobileOpen) {
        root.classList.remove('is-hidden');
        lastScrollY = y;
        return;
      }

      if (y <= 10) {
        root.classList.remove('is-hidden');
      } else if (y > lastScrollY + SCROLL_DELTA) {
        root.classList.add('is-hidden');
      } else if (y < lastScrollY - SCROLL_DELTA) {
        root.classList.remove('is-hidden');
      }

      lastScrollY = y;
    }

    var menuIconOpen = root.querySelector('[data-lsp-menu-icon-open]');
    var menuIconClose = root.querySelector('[data-lsp-menu-icon-close]');

    if (menuToggle && menuPanel) {
      menuToggle.addEventListener('click', function () {
        setMobileOpen(!mobileOpen);
        if (menuIconOpen && menuIconClose) {
          menuIconOpen.hidden = mobileOpen;
          menuIconClose.hidden = !mobileOpen;
        }
      });
      menuPanel.querySelectorAll('[data-lsp-mobile-close]').forEach(function (link) {
        link.addEventListener('click', function () {
          setMobileOpen(false);
        });
      });
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        setSearchOpen(!searchOpen);
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', function () {
        setSearchOpen(false);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (searchOpen) setSearchOpen(false);
        if (mobileOpen) setMobileOpen(false);
      }
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    function refreshCartCount() {
      if (!cartBadge) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count || 0;
          cartBadge.textContent = count > 0 ? String(count) : '';
          cartBadge.dataset.count = String(count);
          var cartLink = root.querySelector('[data-lsp-cart-link]');
          if (cartLink) {
            cartLink.setAttribute('aria-label', count > 0 ? 'Panier (' + count + ' articles)' : 'Panier');
          }
        })
        .catch(function () { /* silencieux */ });
    }

    document.addEventListener('cart:refresh', refreshCartCount);
    document.addEventListener('cart:updated', refreshCartCount);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lsp-header]').forEach(initHeader);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var header = e.target.querySelector('[data-lsp-header]');
    if (header) initHeader(header);
  });
})();
